import { api } from "api/api";
import { AxiosError } from "axios";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import Mdfe from "model/transportes/mdfe/Mdfe";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

export default class MdfeService implements BaseServiceCadastros<Mdfe> {
    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/mdfe/pesquisar`;
            if(filters){
                url += getFilters(filters);
            }

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Mdfe>((resolve, reject): void => {
            api
                .get(`/mdfe/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(mdfe: Mdfe) {
        return new Promise<Mdfe>((resolve, reject): void => {

        });
    }

    editar(mdfe: Mdfe) {
        return new Promise<Mdfe>((resolve, reject): void => {
            api
            .put(`/mdfe/editar`, JSON.stringify(mdfe))
            .then(response => resolve(response.data))
            .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/mdfe/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    importarXml(xmls: string[]) {
        return new Promise<void>((resolve, reject): void => {
            api
                .post('/mdfe/importarXml', xmls)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}